export default "__VITE_ASSET__Ci65hzs$__"